<template>
	<v-dialog
			v-model="value"
			persistent
			origin="top center"
			max-width="700px">
		<v-card class="pa-3 text-md-center">
			<v-card-text>
				<h1 class="page-title">
					{{ title }}
				</h1>
				<slot></slot>
			</v-card-text>

			<v-card-actions>
				<v-btn
						:color="buttonFailColor"
						text
						@click="updateValue(false)">
					{{ buttonFailText }}
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
						:color="buttonSuccessColor"
						@click="pushSuccess">
					{{ buttonSuccessText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		value: Boolean,
		title: String,
		buttonFailColor: String,
		buttonFailText: String,
		buttonSuccessColor: String,
		buttonSuccessText: String,
		body: String,
	},
	methods: {
		updateValue(value) {
			this.$emit('input', value);
		},
		pushSuccess() {
			this.$emit('success');
			this.updateValue(false);
		},
	},
};
</script>
